import { EventEmitter } from 'events';

//TODO: replace this class with AbortController (and polyfill)
export class CancelToken extends EventEmitter {
  constructor() {
    super();
    // this.timeout = timeout && { timeout, start: new Date().getTime() };
  }

  onAbort(callback) {
    this.once('abort', callback);
  }

  isCanceled() {
    return !!this.reason;
  }

  cancel(reason) {
    this.reason = reason || this.reason || new CancelError();
    this.emit('abort', this.reason);
    return this.reason;
  }

  throwIfRequested() {
    // this.checkIfTimeout();

    if (this.reason) {
      throw this.reason;
    }
  }

  static source() {
    return new CancelToken();
  }

  get timeoutError() {
    return new CancelError('Maximum job execution time limit exceeded. If you are running multiple actions at the same time – try separating them to run at different times');
  }
}

export class CancelError extends Error {
  constructor(message) {
    super(message || 'Cancel pending task');
    this.name = this.constructor.name;

    this.constructor = CancelError;
    this.__proto__ = CancelError.prototype;
  }
}
